import React, { useState } from "react";
import styles from "./DebitNotes.module.css";
import { FiEdit2 } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import ResultAndCount from "../../components/ResultAndCount/ResultAndCount";
import Dropdown from "../../components/Dropdown/Dropdown";
import SearchBar from "../../components/SearchBar/SearchBar";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import DynamicTable from "../../components/DynamicTable/DynamicTable";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import IconAndName from "../../components/IconAndName/IconAndName";
import { MdOutlineTextSnippet } from "react-icons/md";
import CopyRight from "../../components/CopyRight/CopyRight";
import { IoMdTrash } from "react-icons/io";
import { useNavigate } from "react-router-dom";

const data = [
  {
    _id: "1",
    studentName: "John Jacob",
    debitId: "DID008",
    dateRaised: "30/06/2025",
    dueDate: "03/07/2025",
    totalAmount: 36099990,
    paidAmount: 2600,
    pendingAmount: 2400,
    latestPayment: 2400,
  },
  {
    _id: "2",
    studentName: "Jane Smith",
    debitId: "DID009",
    dateRaised: "01/06/2025",
    dueDate: "05/07/2025",
    totalAmount: 4000,
    paidAmount: 2000,
    pendingAmount: 2000,
    latestPayment: 2000,
  },
];

const DebitNotes = () => {
  const dispatch = useDispatch();
  const [count, setCount] = useState(7);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);

  const navigate = useNavigate();

  const handlecreateform = () => {
    dispatch(openModal("createDebitNotes"));
  };
  const handleEditClick = () => {
    dispatch(openModal("chooseRange"));
  };
  const handleArchiveClick = () => {
    navigate("/credithistory");
  };
  const totalAmount = data.reduce((sum, d) => sum + (d.totalAmount || 0), 0);
  const totalPaid = data.reduce((sum, d) => sum + (d.paidAmount || 0), 0);
  const totalPending = data.reduce((sum, d) => sum + (d.pendingAmount || 0), 0);

  const headingsData = [
    { title: "Student Name", accessor: "studentName" },
    { title: "Debit ID", accessor: "debitId" },
    { title: "Date Raised", accessor: "dateRaised" },
    { title: "Due Date", accessor: "dueDate" },
    { title: "Total Amount", accessor: "totalAmount" },
    { title: "Paid Amount", accessor: "paidAmount" },
    { title: "Pending", accessor: "pendingAmount" },
    { title: "Latest Payment", accessor: "latestPayment" },
  ];

  const getColumnData = (data) => {
    return data.map((item) => ({
      studentName: <LogoWithName name={item.studentName || "-"} />,
      debitId: item.debitId || "-",
      dateRaised: item.dateRaised || "-",
      dueDate: item.dueDate || "-",
      totalAmount: `INR ${item.totalAmount}`,
      paidAmount: `INR ${item.paidAmount}`,
      pendingAmount: `INR ${item.pendingAmount}`,
      latestPayment: `INR ${item.latestPayment}`,
    }));
  };

  const displayData = getColumnData(data);

  return (
    <>
      <div className={styles.mainContainer}>
        <div className={styles.container}>
          <div className={styles.createForm}>
            <button className={styles.archiveBtn} onClick={handleArchiveClick}>
              Here button not clear
            </button>
            <IconAndName
              icon={<MdOutlineTextSnippet />}
              title="Create Debit Notes"
              bgColor="Primary_Color"
              onClick={handlecreateform}
            />
          </div>
          {/* 🟩 Result Cards + This Month */}
          <div className={styles.rowWrapper}>
            <div className={styles.cardsWrapper}>
              <ResultAndCount
                label="Total Amount"
                count={` ${totalAmount}/-`}
                bgColor="rgba(from var(--Success_Color) r g b / 0.4)"
                textColor="Black_Color"
              />
              <ResultAndCount
                label="Paid Amount"
                count={` ${totalPaid}/-`}
                bgColor="rgba(from var(--Primary_Color) r g b / 0.35)"
                textColor="Black_Color"
              />
              <ResultAndCount
                label="Pending Amount"
                count={` ${totalPending}/-`}
                bgColor="rgba(from var(--Warning_Color) r g b / 0.3)"
                textColor="Black_Color"
              />
            </div>

            <div className={styles.editWrapper} onClick={handleEditClick}>
              <FiEdit2 size={16} />
              <span>This Month</span>
            </div>
          </div>

          {/* 🔍 Search & Filters Row */}
          <div className={styles.totalstudentcard}>
            <div className={styles.studentsection}>
              <div className={styles.search}>
                <SearchBar
                  placeholder="Search Student"
                  onChange={(e) => console.log(e.target.value)}
                />
              </div>
              <div className={styles.filters}>
                <Dropdown
                  label="Program"
                  options={["Annual Day", "Freshers"]}
                  bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
                />
                <Dropdown
                  label="Group"
                  options={["Group 1", "Group 2"]}
                  bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
                />
                <Dropdown
                  label="Room"
                  options={["Room1", "Room2"]}
                  bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
                />
                <Dropdown
                  label=" Status"
                  options={["Annual Day", "Freshers"]}
                  bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
                />
                
              </div>
            </div>

            {/* Student Data Table */}
            <div className={styles.dynamicdata}>
              <DynamicTable
                headings={headingsData}
                columnData={displayData.slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )}
              />
            </div>
            <div className={styles.paginationTable}>
              <PaginationTable
                data={displayData}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </div>
        </div>
      </div>
      <CopyRight />
    </>
  );
};

export default DebitNotes;
